import { InjectionToken } from '@angular/core';

interface OutlookSyncEnvironmentConfig {
  redirectUri: string;
  maximizer: {
    alias: string;
    database: string;
    user: string;
    appId: string;
    clientId: string;
    clientIdEmea?: string;
    onPremClientId?: string;
    globalServicesKey?: string;
    globalServicesUrl?: string;
  };
  microsoft: {
    tenantId: string;
    clientId: string;
    scopes: string[];
  };
}

interface OutlookSyncEnvironment {
  syncConfig: OutlookSyncEnvironmentConfig | undefined;
}

export const OUTLOOK_SYNC_ENV = new InjectionToken<OutlookSyncEnvironment>(
  'OUTLOOK_SYNC_ENV',
);
